module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/缺省插图-找不到页面.f40a9.png";